import React from 'react';
import
    {
        // Button,
        Tooltip,
        IconButton,
        Toolbar,
        Typography,
        Box,
        TextField,
        InputAdornment,
        // Menu,
        // MenuItem,
        Checkbox,
    } from '@mui/material';
// import { alpha } from '@mui/material/styles';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import SearchIcon from '@mui/icons-material/Search';
import Title from '../title/title';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

const NotificationToolBar = (props) =>
{
    const [selectAll, setSelectAll] = React.useState(false);

    const handleSelectAll = (event) =>
    {
        setSelectAll(!selectAll);
        props.onCheckSelectAll(event);
    };
    const deleteRows = () =>
    {
        props.onDelete();
    };
    const allMarkAsRead = (val) =>
    {
        props.updateNotifications(val);
    };
    const refresh = () =>
    {
        props.refresh();
    };

    return (
        <Box style={{ width: '100%' }}>
            <Toolbar
                sx={{
                    paddingLeft: '0px !important',
                    paddingRight: '0px !important',
                    bgcolor: '#fff',
                    height: '0',
                    minHeight: '48px !important',
                    pb: 1,
                    flexWrap: 'wrap',
                }}>
                {props.title != undefined && props.title.length > 0 ? (
                    <Box sx={{ pr: 1.5,m:'16px 0px 0px 16px'}}>
                        <Title title={props.title} />
                    </Box>
                ) : null}
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}>
                        {props.data && props.data.length > 0 ? (
                            <>
                                <Checkbox
                                    inputProps={{
                                        'aria-label': 'AllParticipant',
                                    }}
                                    checked={selectAll}
                                    onChange={(event) => handleSelectAll(event)}
                                    // color="secondary"
                                    disabled={false}
                                    sx={{ marginLeft: 2 }}
                                />
                                {props.showSearch ? (
                                    <TextField
                                        id="search"
                                        size="small"
                                        label={props.searchLabel}
                                        value={props.search}
                                        onChange={props.handleSearchChange}
                                        autoComplete="off"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            mt: 1,
                                            mb: 1,
                                            mr: 1,
                                            ml: 0,
                                            maxWidth: { xs: '100%', md: '90%' },
                                        }}
                                    />
                                ) : null}
                                <Tooltip title="Delete">
                                    <IconButton onClick={deleteRows}>
                                        <DeleteOutlineRoundedIcon
                                            fontSize="small"
                                            color={'default'}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Mark as Read">
                                    <IconButton
                                        onClick={() =>
                                        {
                                            allMarkAsRead(1);
                                        }}>
                                        <DraftsOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Mark as Unread">
                                    <IconButton
                                        onClick={() =>
                                        {
                                            allMarkAsRead(0);
                                        }}>
                                        <MarkunreadOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Refresh">
                                    <IconButton onClick={refresh}>
                                        <CachedOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </>
                        ) : null}
                    </Box>

                    <Box
                        component="div"
                        sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Tooltip title="Delete">
                            <IconButton onClick={deleteRows}>
                                <DeleteOutlineRoundedIcon
                                    fontSize="small"
                                    color={'default'}
                                />
                            </IconButton>
                        </Tooltip> */}

                        {/* <Button variant="text" onClick={allMarkAsRead}>
                            Mark all as Read
                        </Button> */}
                    </Box>
                </Typography>
            </Toolbar>
        </Box>
    );
};

export default NotificationToolBar;
